(function () {
  const wishlistProductCache = new Map();
  let pendingWishlistProduct = null;
  let pendingWishlistWasSelected = false;
  let pendingCartWishlistProduct = null;
  let cartWishlistSaveInFlight = false;
  let lastWishlistToastAt = 0;
  let lastWishlistToastProductUrl = '';

  const WISHLIST_TRIGGER_SELECTOR = [
    '#swym-custom-pdp-button',
    '#swym-custom-pdp-button button',
    '.swym-button',
    '.swym-add-to-wishlist',
    '.swym-advanced-wishlist-collections',
    '[data-swym-add-to-wishlist]',
    '[data-swaction="addToWishlist"]',
    '[data-swaction="removeFromWishlist"]',
    '[data-with-epi]',
  ].join(',');

  const COPY = {
    toast: 'Product added to wishlist successfully',
  };

  const WISHLIST_PLACEHOLDER_SELECTOR = '[data-bmb-swym-placeholder]';
  const HEADER_WISHLIST_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"></path></svg>';
  let headerPlaceholderSyncQueued = false;

  function createHeaderWishlistPlaceholder() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'header__icon header__icon--wishlist bmb-swym-header-placeholder link';
    button.setAttribute('aria-label', 'Wishlist');
    button.setAttribute('aria-pressed', 'false');
    button.dataset.bmbSwymPlaceholder = 'header';
    button.innerHTML =
      HEADER_WISHLIST_SVG +
      '<span class="bmb-swym-header-count" aria-hidden="true" hidden></span>';
    return button;
  }

  function ensureHeaderWishlistPlaceholder() {
    if (typeof window.__bmbEnsureHeaderWishlist === 'function') {
      window.__bmbEnsureHeaderWishlist();
    }

    const icons = document.querySelector('.header__icons');
    if (!icons) return null;

    let placeholder = icons.querySelector('[data-bmb-swym-placeholder="header"]');
    if (!placeholder) {
      placeholder = createHeaderWishlistPlaceholder();
      const cart = icons.querySelector('#cart-icon-bubble, .header__icon--cart');
      icons.insertBefore(placeholder, cart || null);
    }

    if (!placeholder.querySelector('.bmb-swym-header-count')) {
      const countBadge = document.createElement('span');
      countBadge.className = 'bmb-swym-header-count';
      countBadge.setAttribute('aria-hidden', 'true');
      countBadge.hidden = true;
      placeholder.append(countBadge);
    }

    placeholder.removeAttribute('style');
    return placeholder;
  }

  function persistHeaderWishlistPlaceholder() {
    const placeholder = ensureHeaderWishlistPlaceholder();
    neutralizeNativeHeaderLauncher();

    if (placeholder) {
      const actualControl = actualWishlistControlForPlaceholder(placeholder);
      if (actualControl) syncWishlistPlaceholder(placeholder, actualControl);
    }
  }

  function installHeaderWishlistPlaceholderPersistence() {
    if (window.__bmbHeaderWishlistPersistenceInstalled) return;
    window.__bmbHeaderWishlistPersistenceInstalled = true;

    persistHeaderWishlistPlaceholder();

    const target = document.body || document.documentElement;
    const observer = new MutationObserver(() => {
      if (headerPlaceholderSyncQueued) return;
      headerPlaceholderSyncQueued = true;
      queueMicrotask(() => {
        headerPlaceholderSyncQueued = false;
        persistHeaderWishlistPlaceholder();
      });
    });

    observer.observe(target, { childList: true, subtree: true });
    window.__bmbHeaderWishlistStateObserver = observer;
  }

  const NATIVE_HEADER_HIDDEN_STYLES = {
    position: 'fixed',
    left: '-9999px',
    top: '0',
    width: '1px',
    minWidth: '1px',
    maxWidth: '1px',
    height: '1px',
    minHeight: '1px',
    maxHeight: '1px',
    margin: '0',
    padding: '0',
    overflow: 'hidden',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transform: 'none',
  };

  function setImportantStyles(element, styles) {
    if (!(element instanceof HTMLElement)) return;

    Object.entries(styles).forEach(([property, value]) => {
      const cssProperty = property.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
      element.style.setProperty(cssProperty, value, 'important');
    });
  }

  function neutralizeNativeHeaderLauncher() {
    const launcher = document.querySelector('#swym-advanced-header-icon');
    if (!(launcher instanceof HTMLElement)) return;

    setImportantStyles(launcher, NATIVE_HEADER_HIDDEN_STYLES);

    const wrapper = launcher.closest('.shopify-app-block');
    if (wrapper instanceof HTMLElement && wrapper.closest('.header__icons')) {
      setImportantStyles(wrapper, NATIVE_HEADER_HIDDEN_STYLES);
    }
  }

  function actualWishlistControlForPlaceholder(placeholder) {
    if (!(placeholder instanceof Element)) return null;

    if (placeholder.dataset.bmbSwymPlaceholder === 'header') {
      const launcher = document.querySelector('#swym-advanced-header-icon');
      if (!launcher) return null;
      return (
        launcher.querySelector('button, [role="button"], a') ||
        (launcher.matches('button, [role="button"], a') ? launcher : null)
      );
    }

    const wrapper = placeholder.closest('.card-wrapper.product-card-wrapper');
    const container = wrapper?.querySelector('.swym-advanced-wishlist-collections-container');
    if (!container) return null;
    return (
      container.querySelector('button, [role="button"], a') ||
      (container.matches('button, [role="button"], a') ? container : null)
    );
  }

  function nativeWishlistControlIsSelected(actualControl) {
    if (!(actualControl instanceof Element)) return false;

    const container = actualControl.closest(
      '.swym-advanced-wishlist-collections-container, #swym-advanced-header-icon'
    );
    const controls = [actualControl, container].filter(Boolean);

    return controls.some((control) => {
      const action = control.getAttribute('data-swaction') || '';
      const className = typeof control.className === 'string' ? control.className : '';

      return (
        control.getAttribute('aria-pressed') === 'true' ||
        action === 'removeFromWishlist' ||
        /(?:^|\s)(?:swym-added|swym-selected|selected|active)(?:\s|$)/i.test(className) ||
        Boolean(
          control.querySelector(
            '[data-swaction="removeFromWishlist"], [aria-pressed="true"], .swym-added, .swym-selected'
          )
        )
      );
    });
  }

  function syncWishlistPlaceholder(placeholder, actualControl) {
    if (!(placeholder instanceof Element) || !(actualControl instanceof Element)) return;

    const selected = nativeWishlistControlIsSelected(actualControl);
    placeholder.classList.toggle('is-selected', selected);
    placeholder.setAttribute('aria-pressed', String(selected));
    placeholder.dataset.bmbSwymReady = 'true';
    placeholder.removeAttribute('aria-busy');

    if (placeholder.dataset.bmbSwymPlaceholder === 'header') {
      const nativeCount = actualControl.querySelector('[data-swym-count]');
      const count = Number.parseInt(
        nativeCount?.getAttribute('data-count') || nativeCount?.textContent || '0',
        10
      );
      const countBadge = placeholder.querySelector('.bmb-swym-header-count');

      if (countBadge) {
        const nextCountText = String(Number.isFinite(count) ? count : 0);
        const shouldHideCount = !Number.isFinite(count) || count < 1;

        if (countBadge.textContent !== nextCountText) {
          countBadge.textContent = nextCountText;
        }

        if (countBadge.hidden !== shouldHideCount) {
          countBadge.hidden = shouldHideCount;
        }
      }

      placeholder.setAttribute(
        'aria-label',
        count > 0 ? `Wishlist, ${count} ${count === 1 ? 'item' : 'items'}` : 'Wishlist'
      );
    }
  }

  function scheduleWishlistPlaceholderSync(placeholder) {
    [0, 80, 220, 500].forEach((delay) => {
      window.setTimeout(() => {
        const actualControl = actualWishlistControlForPlaceholder(placeholder);
        if (actualControl) syncWishlistPlaceholder(placeholder, actualControl);
      }, delay);
    });
  }

  function hydrateWishlistPlaceholders() {
    neutralizeNativeHeaderLauncher();

    document.querySelectorAll(WISHLIST_PLACEHOLDER_SELECTOR).forEach((placeholder) => {
      const actualControl = actualWishlistControlForPlaceholder(placeholder);
      if (!actualControl || actualControl === placeholder) return;

      const shouldForwardClick = placeholder.dataset.bmbPending === 'true';
      syncWishlistPlaceholder(placeholder, actualControl);

      if (shouldForwardClick && actualControl.dataset.bmbPlaceholderForwarded !== 'true') {
        actualControl.dataset.bmbPlaceholderForwarded = 'true';
        delete placeholder.dataset.bmbPending;
        window.requestAnimationFrame(() => {
          actualControl.click();
          scheduleWishlistPlaceholderSync(placeholder);
        });
      }
    });

    neutralizeNativeHeaderLauncher();
  }

  function installWishlistPlaceholderFallback() {
    if (window.__bmbSwymPlaceholderFallbackInstalled) return;
    window.__bmbSwymPlaceholderFallbackInstalled = true;

    document.addEventListener(
      'click',
      (event) => {
        const placeholder =
          event.target instanceof Element
            ? event.target.closest(WISHLIST_PLACEHOLDER_SELECTOR)
            : null;
        if (!placeholder) return;

        event.preventDefault();
        event.stopPropagation();

        const actualControl = actualWishlistControlForPlaceholder(placeholder);
        if (actualControl && actualControl !== placeholder) {
          if (placeholder.dataset.bmbSwymPlaceholder === 'card') {
            const selected = placeholder.getAttribute('aria-pressed') === 'true';
            placeholder.classList.toggle('is-selected', !selected);
            placeholder.setAttribute('aria-pressed', String(!selected));
          }
          actualControl.click();
          scheduleWishlistPlaceholderSync(placeholder);
          return;
        }

        placeholder.dataset.bmbPending = 'true';
        placeholder.setAttribute('aria-busy', 'true');
      },
      true
    );
  }

  function escapeHtml(value = '') {
    return String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    })[character]);
  }

  function safeHttpUrl(value, fallback = '') {
    try {
      const url = new URL(String(value || fallback), window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function unwrapImage(value) {
    if (Array.isArray(value)) return unwrapImage(value[0]);

    if (value && typeof value === 'object') {
      return value.src || value.url || value.originalSrc || '';
    }

    return value || '';
  }

  function configureConsentPopup() {
    const popup = document.getElementById('swym-consent-popup');

    if (!popup) return false;

    popup.dataset.toastMessage = COPY.toast;
    return true;
  }

  function cartWishlistProductFromTarget(target) {
    if (!(target instanceof Element)) return null;

    const removeControl = target.closest('cart-remove-button a, cart-remove-button button');
    const row = removeControl?.closest('.cart-item[data-bmb-product-url]');
    if (!row) return null;

    return {
      empi: Number(row.dataset.bmbProductId) || null,
      epi: Number(row.dataset.bmbVariantId) || null,
      du: row.dataset.bmbProductUrl || '',
      dt: row.dataset.bmbProductTitle || '',
      iu: row.dataset.bmbProductImage || '',
      pr: Number(row.dataset.bmbProductPrice) || null,
      url: row.dataset.bmbProductUrl || '',
      title: row.dataset.bmbProductTitle || '',
      image: row.dataset.bmbProductImage || '',
    };
  }

  function enhanceCartWishlistModal() {
    const dialog = document.querySelector('.swym-sfl-popup-dialog');
    if (!dialog) return false;

    dialog.classList.add('bmb-cart-wishlist-modal');

    const isFrench = document.documentElement.lang?.toLowerCase().startsWith('fr');
    const heading = dialog.querySelector('.swym-modal-heading');
    const cancelButtons = dialog.querySelectorAll('.swym-sfl-popup-cancel');
    const saveButtons = dialog.querySelectorAll('.swym-sfl-popup-save-btn');

    if (heading) {
      heading.textContent = isFrench
        ? 'Enregistrer ce kit dans votre liste d’envies ?'
        : 'Save this kit to your wishlist?';
    }

    cancelButtons.forEach((button) => {
      button.textContent = isFrench ? 'Supprimer seulement' : 'Remove only';
      button.setAttribute('aria-label', button.textContent);
    });

    saveButtons.forEach((button) => {
      button.textContent = isFrench ? 'Enregistrer dans mes favoris' : 'Save to wishlist';
      button.setAttribute('aria-label', button.textContent);
    });

    return true;
  }

  function addCartProductToWishlist(product) {
    return new Promise((resolve, reject) => {
      const saveLocally = () => {
        const localWishlist = window.SwymLocalWishlist;
        if (!localWishlist?.addItem) {
          reject(new Error('Wishlist is not ready'));
          return;
        }

        if (!localWishlist.isWishlisted?.(product)) {
          localWishlist.addItem(product);
          localWishlist.incrementClickCounter?.();
        }
        resolve(product);
      };

      const swat = window._swat;
      if (swat?.addToWishlistUsingDu) {
        swat.addToWishlistUsingDu(
          { du: product.du, source: swat.wishlistSources?.cart || 'cart' },
          (response) => {
            if (response?.error) {
              reject(response.error);
              return;
            }
            resolve(product);
          },
          reject
        );
        return;
      }

      const localWishlist = window.SwymLocalWishlist;
      if (
        localWishlist?.requiresLocalStorageConsent?.() &&
        window.SwymConsentPopupManager?.show
      ) {
        window.SwymConsentPopupManager.show({
          source: 'bmb-cart-wishlist',
          localOnly: true,
          pendingAction: saveLocally,
        });
        return;
      }

      saveLocally();
    });
  }

  function installCartWishlistBridge() {
    if (window.__bmbCartWishlistBridgeInstalled) return;
    window.__bmbCartWishlistBridgeInstalled = true;

    const rememberCartProduct = (event) => {
      const product = cartWishlistProductFromTarget(event.target);
      if (product) pendingCartWishlistProduct = product;
    };

    document.addEventListener('pointerdown', rememberCartProduct, true);
    document.addEventListener('click', rememberCartProduct, true);

    document.addEventListener(
      'click',
      async (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const saveButton = target?.closest('.swym-sfl-popup-save-btn');
        if (!saveButton || !pendingCartWishlistProduct || cartWishlistSaveInFlight) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        cartWishlistSaveInFlight = true;
        saveButton.disabled = true;
        saveButton.setAttribute('aria-busy', 'true');

        try {
          await addCartProductToWishlist(pendingCartWishlistProduct);
          pendingWishlistProduct = pendingCartWishlistProduct;
          showWishlistToast(pendingCartWishlistProduct);
          saveButton.closest('.swym-modal-content')?.querySelector('.swym-cc-close-icon')?.click();
          pendingCartWishlistProduct = null;
        } catch (error) {
          saveButton.textContent = 'Please try again';
          saveButton.disabled = false;
        } finally {
          cartWishlistSaveInFlight = false;
          saveButton.removeAttribute('aria-busy');
        }
      },
      true
    );
  }

  function initializeWishlistCopy() {
    installHeaderWishlistPlaceholderPersistence();
    configureConsentPopup();
    enhanceGhostWishlist();
    enhanceStorefrontWishlist();
    installWishlistToastListener();
    installWishlistTriggerFallback();
    installWishlistPlaceholderFallback();
    installCartWishlistBridge();
    enhanceCartWishlistModal();
    hydrateWishlistPlaceholders();

    [0, 50, 150, 400, 1000, 2500, 5000].forEach((delay) => {
      window.setTimeout(() => {
        neutralizeNativeHeaderLauncher();
        hydrateWishlistPlaceholders();
      }, delay);
    });

    let enhancementFrame = 0;
    const observer = new MutationObserver(() => {
      if (enhancementFrame) return;

      enhancementFrame = window.requestAnimationFrame(() => {
        enhancementFrame = 0;
        configureConsentPopup();
        enhanceGhostWishlist();
        enhanceStorefrontWishlist();
        enhanceCartWishlistModal();
        neutralizeNativeHeaderLauncher();
        hydrateWishlistPlaceholders();
      });
    });

    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function wishlistDateLabel() {
    const locale = document.documentElement.lang?.toLowerCase().startsWith('fr')
      ? 'fr-FR'
      : 'en-GB';

    return new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(new Date());
  }

  function formatWishlistPrice(priceInCents) {
    const locale = document.documentElement.lang?.toLowerCase().startsWith('fr')
      ? 'fr-FR'
      : 'en-GB';
    const currency = window.Shopify?.currency?.active || 'EUR';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(Number(priceInCents || 0) / 100);
  }

  async function getWishlistProduct(productPath) {
    if (!productPath) return null;

    const normalizedPath = productPath.split('?')[0].replace(/\.js$/, '');

    if (!wishlistProductCache.has(normalizedPath)) {
      const request = fetch(`${normalizedPath}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
          return response.json();
        })
        .catch(() => null);

      wishlistProductCache.set(normalizedPath, request);
    }

    return wishlistProductCache.get(normalizedPath);
  }

  async function normalizeWishlistItemPrice(item) {
    const price = item.querySelector('.swym-ghost-wl-item-price');
    const productPath = item.dataset.du || item.querySelector('.swym-ghost-wl-item-title')?.pathname;

    if (
      !price ||
      !productPath ||
      ['loading', 'done'].includes(item.dataset.bmbPriceState)
    ) {
      return;
    }

    item.dataset.bmbPriceState = 'loading';
    const product = await getWishlistProduct(productPath);

    if (!product) {
      item.dataset.bmbPriceState = 'error';
      return;
    }

    const selectedVariant =
      product.variants?.find((variant) => variant.available) || product.variants?.[0];
    const priceInCents = selectedVariant?.price ?? product.price;

    if (Number.isFinite(Number(priceInCents))) {
      const formattedPrice = formatWishlistPrice(priceInCents);
      if (price.textContent.trim() !== formattedPrice) price.textContent = formattedPrice;
      item.dataset.bmbPriceState = 'done';
    }
  }

  function currentWishlistProduct(fallback = {}) {
    const source = fallback?.detail || fallback || {};
    const data = source.data || {};
    const productData = source.product || source.productData || data.product || data;
    const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.href;
    const handle = productData.handle || source.handle || '';
    const title =
      source.title ||
      source.dt ||
      productData.title ||
      source.productName ||
      source.name ||
      document.querySelector('meta[property="og:title"]')?.content ||
      document.querySelector('.product__title h1, h1')?.textContent?.trim() ||
      document.title;
    const rawImage =
      source.image ||
      source.iu ||
      productData.image ||
      productData.featured_image ||
      productData.featuredImage ||
      source.productImage ||
      source.imageUrl ||
      document.querySelector('meta[property="og:image"]')?.content ||
      '';
    const rawUrl =
      source.url ||
      source.du ||
      productData.url ||
      source.productUrl ||
      (handle ? `/products/${handle}` : '') ||
      canonical;

    return {
      title: String(title || ''),
      image: safeHttpUrl(unwrapImage(rawImage), ''),
      url: safeHttpUrl(rawUrl, canonical),
    };
  }

  function wishlistTriggerFromEventTarget(target) {
    if (!(target instanceof Element)) return null;

    const trigger = target.closest(WISHLIST_TRIGGER_SELECTOR);
    if (!trigger) return null;
    if (trigger.closest('#swym-ghost-wishlist-drawer, swym-storefront-layout-as-drawer')) {
      return null;
    }

    return trigger;
  }

  function isWishlistSelected(trigger) {
    const button = trigger.matches('button')
      ? trigger
      : trigger.querySelector('button') || trigger;
    const label = `${button.getAttribute('aria-label') || ''} ${
      button.getAttribute('title') || ''
    }`.toLowerCase();

    return (
      button.getAttribute('aria-pressed') === 'true' ||
      button.classList.contains('swym-added') ||
      button.classList.contains('swym-added-to-wishlist') ||
      button.dataset.swaction === 'removeFromWishlist' ||
      label.includes('remove')
    );
  }

  function productFromWishlistTrigger(trigger) {
    const root =
      trigger.closest(
        '.card-wrapper, .product-card-wrapper, .card, .grid__item, product-info, .product, main'
      ) || document;
    const dataNode =
      (trigger.matches('[data-du],[data-iu],[data-dt]') && trigger) ||
      trigger.querySelector('[data-du],[data-iu],[data-dt]') ||
      trigger.closest('[data-du],[data-iu],[data-dt]') ||
      trigger;
    const link =
      root.querySelector('a[href*="/products/"]') ||
      trigger.closest('a[href*="/products/"]');
    const titleElement = root.querySelector(
      '.card__heading a, .full-unstyled-link[href*="/products/"], .product__title h1, h1'
    );
    const imageElement = root.querySelector('img');

    return currentWishlistProduct({
      title:
        dataNode.dataset.dt ||
        dataNode.dataset.title ||
        dataNode.dataset.productTitle ||
        titleElement?.textContent?.trim() ||
        '',
      image:
        dataNode.dataset.iu ||
        dataNode.dataset.image ||
        imageElement?.currentSrc ||
        imageElement?.src ||
        '',
      url:
        dataNode.dataset.du ||
        dataNode.dataset.url ||
        link?.href ||
        window.location.href,
    });
  }

  function dismissWishlistToast() {
    const toast = document.getElementById('bmb-swym-success-toast');
    if (!toast) return;

    toast.classList.remove('is-visible');
    window.setTimeout(() => toast.remove(), 240);
  }

  function showWishlistToast(eventData = {}) {
    const source = eventData?.detail || eventData || {};
    const product = currentWishlistProduct({
      ...source,
      ...(pendingWishlistProduct || {}),
    });
    const now = Date.now();

    if (
      product.url === lastWishlistToastProductUrl &&
      now - lastWishlistToastAt < 2500 &&
      document.getElementById('bmb-swym-success-toast')
    ) {
      pendingWishlistProduct = null;
      return;
    }

    lastWishlistToastAt = now;
    lastWishlistToastProductUrl = product.url;
    pendingWishlistProduct = null;
    document.getElementById('bmb-swym-success-toast')?.remove();

    const toast = document.createElement('aside');
    toast.id = 'bmb-swym-success-toast';
    toast.className = 'bmb-swym-success-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.innerHTML =
      '<div class="bmb-swym-success-toast__header">' +
      '<span class="bmb-swym-success-toast__heart" aria-hidden="true">&#9829;</span>' +
      '<strong>' + escapeHtml(COPY.toast) + '</strong>' +
      '<button type="button" class="bmb-swym-success-toast__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<a class="bmb-swym-success-toast__product' +
      (product.image ? ' has-image' : '') +
      '" href="' +
      escapeHtml(product.url) +
      '">' +
      (product.image
        ? '<img src="' + escapeHtml(product.image) + '" alt="" width="84" height="84">'
        : '') +
      '<span>' + escapeHtml(product.title) + '</span></a>';

    toast.querySelector('.bmb-swym-success-toast__close')?.addEventListener(
      'click',
      dismissWishlistToast
    );
    document.body.appendChild(toast);
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));

    // Keep Swym's consent/login prompt available so the wishlist can be
    // associated with the customer's account instead of remaining local-only.
    configureConsentPopup();

    window.clearTimeout(window.__bmbSwymToastTimer);
    window.__bmbSwymToastTimer = window.setTimeout(dismissWishlistToast, 5200);
  }

  function installWishlistToastListener() {
    if (window.__bmbSwymToastListenerInstalled) return;
    window.__bmbSwymToastListenerInstalled = true;

    const register = (swat) => {
      if (!swat?.evtLayer?.addEventListener || !swat?.JSEvents?.addedToWishlist) return;
      if (swat.__bmbSuccessToastRegistered) return;

      swat.__bmbSuccessToastRegistered = true;
      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, showWishlistToast);
    };

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(register);
    if (window._swat) register(window._swat);
  }

  function installWishlistTriggerFallback() {
    if (window.__bmbSwymClickFallbackInstalled) return;
    window.__bmbSwymClickFallbackInstalled = true;

    const rememberTrigger = (event) => {
      const trigger = wishlistTriggerFromEventTarget(event.target);
      if (!trigger) return;

      pendingWishlistWasSelected = isWishlistSelected(trigger);
      pendingWishlistProduct = productFromWishlistTrigger(trigger);
    };

    document.addEventListener('pointerdown', rememberTrigger, true);
    document.addEventListener(
      'click',
      (event) => {
        const trigger = wishlistTriggerFromEventTarget(event.target);
        if (!trigger) return;

        const wasSelected = pendingWishlistProduct
          ? pendingWishlistWasSelected
          : isWishlistSelected(trigger);
        const clickedProduct = productFromWishlistTrigger(trigger);

        pendingWishlistProduct = clickedProduct;
        pendingWishlistWasSelected = wasSelected;

        if (wasSelected) {
          pendingWishlistProduct = null;
          return;
        }
      },
      true
    );
  }

  function enhanceGhostWishlist() {
    const drawer = document.getElementById('swym-ghost-wishlist-drawer');

    if (!drawer) return;

    const items = drawer.querySelector('.swym-ghost-wl-items');
    drawer.querySelectorAll('.swym-ghost-wl-item').forEach((item) => {
      const title = item.querySelector('.swym-ghost-wl-item-title');

      normalizeWishlistItemPrice(item);

      if (title && !item.querySelector('.bmb-swym-item-date')) {
        const date = document.createElement('span');
        date.className = 'bmb-swym-item-date';
        date.textContent = wishlistDateLabel();
        title.insertAdjacentElement('afterend', date);
      }
    });

    if (items && !drawer.querySelector('.bmb-swym-bulk-actions')) {
      const toolbar = document.createElement('div');
      toolbar.className = 'bmb-swym-bulk-actions';
      toolbar.innerHTML =
        '<div class="bmb-swym-bulk-actions-left">' +
        '<button type="button" data-bmb-add-all>ADD ALL TO CART</button>' +
        '<button type="button" data-bmb-remove-all>REMOVE ALL FROM WISHLIST</button>' +
        '</div>' +
        '<button type="button" class="bmb-swym-share" data-bmb-share>' +
        '<span aria-hidden="true">&#8982;</span> SHARE WISHLIST' +
        '</button>';

      toolbar.querySelector('[data-bmb-add-all]')?.addEventListener('click', () => {
        drawer.querySelectorAll('.swym-ghost-wl-item-atc:not(:disabled)').forEach((button) => {
          button.click();
        });
      });

      toolbar.querySelector('[data-bmb-remove-all]')?.addEventListener('click', () => {
        Array.from(drawer.querySelectorAll('.swym-ghost-wl-item-remove')).forEach(
          (button, index) => {
            window.setTimeout(() => button.click(), index * 80);
          }
        );
      });

      toolbar.querySelector('[data-bmb-share]')?.addEventListener('click', async () => {
        const shareData = {
          title: 'My Wishlist',
          text: 'My Bright My Bricks wishlist',
          url: window.location.href,
        };

        if (navigator.share) {
          try {
            await navigator.share(shareData);
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }

        try {
          await navigator.clipboard.writeText(shareData.url);
          const shareButton = toolbar.querySelector('[data-bmb-share]');
          const originalText = shareButton.innerHTML;
          shareButton.textContent = 'LINK COPIED';
          window.setTimeout(() => {
            shareButton.innerHTML = originalText;
          }, 1800);
        } catch (error) {
          window.prompt('Copy your wishlist link', shareData.url);
        }
      });

      items.insertAdjacentElement('afterend', toolbar);
    }
  }

  function enhanceStorefrontWishlist() {
    const wishlist = document.querySelector('swym-storefront-layout-default-wishlist');
    if (!wishlist) return;

    wishlist.querySelectorAll('swym-storefront-layout-item').forEach((item) => {
      const title = item.querySelector('.swym-storefront-layout-grid-item-title');
      if (title && !item.querySelector('.bmb-swym-storefront-item-date')) {
        const date = document.createElement('span');
        date.className = 'bmb-swym-storefront-item-date';
        date.textContent = wishlistDateLabel();
        title.insertAdjacentElement('afterend', date);
      }
    });

    if (!wishlist.querySelector('.bmb-swym-storefront-bulk-actions')) {
      const toolbar = document.createElement('div');
      toolbar.className = 'bmb-swym-storefront-bulk-actions';
      toolbar.innerHTML =
        '<button type="button" data-bmb-storefront-add-all>ADD ALL TO CART</button>' +
        '<button type="button" data-bmb-storefront-remove-all>REMOVE ALL FROM WISHLIST</button>';

      toolbar.querySelector('[data-bmb-storefront-add-all]')?.addEventListener('click', () => {
        wishlist
          .querySelectorAll('.swym-storefront-layout-grid-item-add-to-cart-button:not(:disabled)')
          .forEach((button) => button.click());
      });

      toolbar.querySelector('[data-bmb-storefront-remove-all]')?.addEventListener('click', () => {
        Array.from(wishlist.querySelectorAll('.swym-storefront-layout-delete-btn')).forEach(
          (button, index) => window.setTimeout(() => button.click(), index * 90)
        );
      });

      wishlist.querySelector('.swym-storefront-layout-default-list-container')?.append(toolbar);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWishlistCopy, { once: true });
  } else {
    initializeWishlistCopy();
  }
})();
